<script setup lang="ts">

import { GetTheAppButton } from "@components/GetTheAppButton";
import { ContactSalesButton } from "@components/ContactSalesButton";

import FeaturePanel from './Components/FeaturePanel.vue';
import Headline from "./Components/Headline.vue";
import WhatsIncluded from "./Components/WhatsIncluded.vue";
import GetCarbucksProtectPanel from "./Components/GetCarbucksProtectPanel.vue";

</script>

<template>

    <div class="max-w-5xl mx-auto px-4">
    
        <Headline />
        <WhatsIncluded />

        <div class="max-w-5xl mx-auto px-8 flex flex-col gap-20">

            <!-- WIPER BLADES -->
            <FeaturePanel :is-reversed="false">

                <template #image>
                    <img src="@/assets/images/CarbucksProtect/wiper-blades.jpg" class="w-full"/>
                </template>
            
                <template #headline>
                    Wiper Blades
                </template>          


                <p class="mb-2">
                    Clear Visibility, Always - Worn-out front and rear wipers replaced for optimal driving safety.
                </p>

            </FeaturePanel>

            <!-- BATTERY -->
            <FeaturePanel :is-reversed="true">

                <template #image>
                    <img src="@/assets/images/CarbucksProtect/battery.jpg" class="w-full"/>
                </template>
            
                <template #headline>
                    12-volt Battery
                </template>          


                <p class="mb-2">
                    Never Get Stuck - If your battery fails due to normal wear and tear, we'll replace it with a new one.
                </p>

            </FeaturePanel>

            <!-- BRAKES -->
            <FeaturePanel :is-reversed="false">

                <template #image>
                    <img src="@/assets/images/CarbucksProtect/brakes.jpg" class="w-full"/>
                </template>
            
                <template #headline>
                    Brake Safety
                </template>          

                <p class="mb-2">
                    Reliable Braking, Every Time - Worn-out brake pads, rotors, or drums from regular use, we'll replace them.
                </p>

            </FeaturePanel>
            
            <!-- KEY FOB -->
            <FeaturePanel :is-reversed="true">

                <template #image>
                    <img src="@/assets/images/CarbucksProtect/key-fob-repair.jpg" class="w-full"/>
                </template>
            
                <template #headline>
                    Key Fob
                </template>          

                <p class="mb-2">
                    No More Malfunctions - Issues like battery replacement, button repairs, casing fixes, and recoding.
                </p>

                <p class="mb-2">
                    Full Replacement If Needed - If parts aren't available, we'll replace the fob.
                </p>

            </FeaturePanel>
            
            <!-- TYRES -->
            <FeaturePanel :is-reversed="false">

                <template #image>
                    <img src="@/assets/images/CarbucksProtect/tyres.jpg" class="w-full"/>
                </template>
            
                <template #headline>
                    Tyre Safety
                </template>          


                <p class="mb-2">
                    Drive with Confidence - Worn-out tyres replaced due to normal wear and tear or if your tyre is punctured or damaged by road hazards, we'll repair or replace it.
                </p>

            </FeaturePanel>

            <!-- CONCIERGE -->
            <FeaturePanel :is-reversed="true">

                <template #image>
                    <img src="@/assets/images/CarbucksProtect/concierge.png" class="w-full"/>
                </template>
            
                <template #headline>
                    Concierge Service
                </template>          


                <p class="mb-2">
                    Hassle-Free Service Requests - We handle everything for you. Claims, service bookings, and support.
                </p>

            </FeaturePanel>
            
        </div>

        <div class="flex flex-col md:flex-row max-w-5xl mx-auto gap-12 max-auto px-8 mt-16 mb-16">
            <div class="flex flex-col md:w-1/2">
                <GetCarbucksProtectPanel class="h-full">
                    <div class="flex flex-col h-full">
                        <h1 class="text-3xl font-semibold mb-4 flex-grow">
                            Own a dealership?
                            <br class="hidden md:block"/>
                            Add real value for your customers
                        </h1>
                        <ContactSalesButton />
                    </div>
                </GetCarbucksProtectPanel>
            </div>
            <div class="flex flex-col md:w-1/2">
                <GetCarbucksProtectPanel class="h-full">
                    <div class="flex flex-col h-full">
                        <h1 class="text-3xl font-semibold mb-4 flex-grow">
                            Want to see how it can benefit 
                            <br class="hidden md:block"/>
                            your driving experience?
                        </h1>
                        <GetTheAppButton :show-get-in-touch="false" />
                    </div>
                </GetCarbucksProtectPanel>
            </div>
        </div>
            
    </div>

</template>